import Compressor from 'compressorjs';
import { tipoNotificacionEnum } from '../utils/constanst';
import { sexo, estadoCivil } from './mochaData'


const env = process.env.NODE_ENV;
const initPage = 0;
const isDevelopment = env === "development";
const setData = isDevelopment || false;

export const planes = {
    planDolares: 511,
    planColones: 510
}

const formatNumber = (value) => (value === '' || value === undefined || value === null) ? 0 : parseInt(value);


export const paginaAutoCr = {
    paginaDatosPersonales: 2,
    paginaConyuge: 3,
    paginaActividadEconomica: 4,
    paginaFatcaCicac: 5,
    paginaDatosVeh: 6,
    paginaPasarela: 8,
    paginaAutoUsado: 9,
    paginaAutoUsadoFinal: 10,
    paginaNoAcepta: 11,
    StepDebitoAutomatico: 12
}

export const tarificacionDefault = {
    itipopol: 'I',
    VigenciaPol: 'A',
    ncuotas: 1,
    marc: 0,
    mode: -1,
    anio: 0,
    tipo: 0,
    cate: 0,
    usoo: 1,
    nasiento: 0,
    valn: 0,
    suma: 0,
    valnreal: 0,
    GPS: 0,
    dedu: 0,
    rsat: 1,
    auNuevo: 0,
    showDialogFail: false
};

const aseguradoDat = {
    tipoId: 3,
    identificacion: '000-010100-0000J',
    nombre: 'Eddy Antonio',
    apellido: 'Ortiz Amador',
    email: 'eortiza@lafise.com',
    celular: '88888888',
    showModal: false,
    showAcceptModel: false,
    sendDisabled: false
}

export const polizaDefault = {
    id: 0,
    file: {
        0: null,
        1: null,
        2: null
    },
    auFiles: {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
    },
    auFilesUsado: {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
    },
    planId: planes.planDolares,
    moneda: 'U$',
    frecuenciaPagos: '1',
    polCobs: [],
    planesConfig: [{
        id: planes.planDolares,
        diaMinInicioVigencia: 0,
        diaMaxInicioVigencia: 60,
    }, {
        id: planes.planColones,
        diaMinInicioVigencia: 0,
        diaMaxInicioVigencia: 60,
    }],
    nombreTarjeta: '',
    showCaptchaValidation: true,
    asegurado: setData ? { ...aseguradoDat } : {},
    aseguradoId: 0,
    sendNotificationAuto: !setData,
    prima: setData ? 2000 : 0,
    sa: setData ? 1234546 : 0,
    primaAnual: setData ? 1200 : 0,
    primaSemestral: setData ? 600 : 0,
    primaTrimestral: setData ? 300 : 0,
    primaMensual: setData ? 100 : 0,
    pasarela: {
        expirationDate: '',
        cardHolder: '',
        cardNumber: ''
    },
    tipoIdConyuge: '1',
    aceptaCICAC: undefined,
    motivoid: 0,
    motivotxt: '',
    comentariosCICAC: '',
    CICACGuardado: false,
    statusAccount: 0,
    transactionId: 0,
    valorEquipoEspecial: 0,
    nombreEquipoEspecial: '',
    nacionalidad: ''

}

export const catalogosDefault = {
    rastreoSatelital: [],
    deducibles: [],
    marcas: [],
    modelos: [],
    anios: [],
    usos: [],
    coberturas: []
}




export const dataDefault = setData ? { ...aseguradoDat } : { tipoId: '1', identificacion: '', nombre: '', apellido: '', email: '', celular: '', showModal: false, showAcceptModel: false, sendDisabled: false };





export const cotizadorDefault = {
    poliza: { ...polizaDefault },
    asegurado: {},
    tarificacion: { ...tarificacionDefault },
    catalogos: { ...catalogosDefault },
    setTarificacion: (obj) => { },
    setPoliza: (obj) => { },
    setCatalogos: (obj) => { },
    polizaChangeHandler: (event) => { },
    tarificacionChangeHandler: (event) => { },
    loading: false,
    sendNotification: false,
    init: false
}

export const coberturasRequeridas = [61, 62, 63, 64, 65, 66, 78];
export const coberturasOpcionales = [180, 264, 144, 211, 257];

export const coberturaEquipoEspecial = 264;
export const coberturaDeducibleCero = 144;
export const coberturaServiciosDentales = 257;

const clearCoberturasOpcionales = () => {
    let data = {};
    coberturasOpcionales.forEach(x => data[`Cob${x}`] = 0);
    return data;
}

export const buildTarificacionData = (planId, t) => {


    let data = {
        itipopol: 'I',
        VigenciaPol: 'A',
        ...t,
        cate: t.auCategoria,
        nasiento: t.auNumPasajeros,
        suma: t.valn,
        tipo: t.auTipo,
        //Codigos de descuento
        codigo2: 0,
        codigo5: 0,
        codigo8: 0,

    }

    if (planId == planes.planDolares) {

        if (isOldVh(data.anio)) {
            return {
                ...data,
                coverageIds: "[61,62,78]",
                CobSA61: 600000,
                CobSA62: 100000,
                Cob61: 1,
                Cob62: 1,
                Cob78: 1
            };
        }

        data = {
            ...data,
            coverageIds: "[61,62,63,64,65,66,78]",
            CobSA61: 600000,
            CobSA62: 100000,
            Cob61: 1,
            Cob62: 1,
            Cob63: 1,
            Cob64: 1,
            Cob65: 1,
            Cob66: 1,
            Cob78: 1,
            ...clearCoberturasOpcionales()
        }
    }
    else if (planId == planes.planColones) {
        if (isOldVh(data.anio)) {
            return {
                ...data,
                coverageIds: "[61,62,78]",
                CobSA61: 300000000,
                CobSA62: 50000000,
                Cob61: 1,
                Cob62: 1,
                Cob78: 1
            };
        }

        data = {
            ...data,
            coverageIds: "[61,62,63,64,65,66,78]",
            CobSA61: 300000000,
            CobSA62: 50000000,
            Cob61: 1,
            Cob62: 1,
            Cob63: 1,
            Cob64: 1,
            Cob65: 1,
            Cob66: 1,
            Cob78: 1,
            ...clearCoberturasOpcionales()
        }
    }
    return data;
}

const ResizeFile = async (file) => {
    return new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            type: "file",
            success(result) {
                resolve(result);
            }
        });
    });

}

const CreateNewFile = async (file) => {
    const newFile = await ResizeFile(file)
    const newFile2 = new File([newFile], newFile.name, { lastModified: newFile.lastModified, type: newFile.type, name: newFile.name });
    return newFile2
}

export const buildDataNotification = async (poliza, tipo) => {

    let data = {
        idPoliza: poliza.id,
        idOportunidad: '',
        nombre: `${poliza.asegurado.nombre} ${poliza.asegurado.apellido}`,
        correo: poliza.asegurado.email,
        celular: poliza.asegurado.celular,
        tipoNotificacion: tipo,
        adjuntos: []
    }
    const Adjuntos = [];

    switch (tipo) {
        case tipoNotificacionEnum.DocumentoIdentidad:
            if (poliza.file !== null) {
                if (poliza.file['0'] !== null)
                    Adjuntos.push(await CreateNewFile(poliza.file['0']));
                if (poliza.file['1'] !== null)
                    Adjuntos.push(await CreateNewFile(poliza.file['1']));
            }
            break;
        case tipoNotificacionEnum.FacturaEquiposEspeciales:
            if (poliza.auFiles !== null) {
                if (poliza.auFiles['1'] !== null)
                    Adjuntos.push(await CreateNewFile(poliza.auFiles['1']));
            }
            break;
        case tipoNotificacionEnum.InspeccionVehiculo:
            if (poliza.auFilesUsado !== null) {
                for (let i = 0; i < 5; i++) {
                    if (poliza.auFilesUsado[`${i}`] !== null)
                        Adjuntos.push(await CreateNewFile(poliza.auFilesUsado[`${i}`]));
                }
            }
            break;
        case tipoNotificacionEnum.FacturaProforma:
            if (poliza.auFiles !== null) {
                if (poliza.auFiles['0'] !== null)
                    Adjuntos.push(await CreateNewFile(poliza.auFiles['0']));
            }
            break;
        default:
            break;
    }

    if (Adjuntos.length > 0)
        data.adjuntos = Adjuntos;

    return data;
}

export const bulidDataToSave = (poliza, t, catalogos) => {

    let getfrecuencia = (n) => {
        switch (n) {
            case '12': return 'M'
            case '4': return 'T'
            case '2': return 'S'
            case '1': return 'A'
            default: return 'A'
        }
    }

    const isNullOrEmpty = (s) => s == null || s == '';

    let polCobsDesc = [];
    let oaTemp = [];

    poliza.polCobs.forEach((x, i) => {
        let mrecargo = 0;
        x.prima = parseFloat(x.prima).toFixed(2);
        if (x.pRecargo > 0)
            mrecargo = parseFloat(parseFloat(x.prima).toFixed(2) * ((parseFloat(x.pRecargo) / 100).toFixed(2) + 1)).toFixed(2);
        x.prima = parseFloat(parseFloat(x.prima) + parseFloat(mrecargo)).toFixed(2);
        let descuento = 0;
        let pdescuento = 0;
        if (x.descuentos !== undefined && x.descuentos !== null && x.descuentos.length > 0)
            pdescuento = parseFloat(x.descuentos[0].porcentaje).toFixed(2);
        if (pdescuento !== 0)
            descuento = parseFloat(parseFloat(x.prima) * (pdescuento / 100).toFixed(2)).toFixed(2);
        x.mPrimaBruta = parseFloat(parseFloat(x.prima) - descuento).toFixed(2);
        x.pdescuento = pdescuento;
        x.mdescuento = descuento;
        x.PrimaGravada = x.mPrimaBruta;
        x.PrimaDE = x.mPrimaBruta;
        x.orden = i + 1;

        if (descuento > 0) {
            let polCobsDescTemp = {};
            polCobsDescTemp["idCob"] = x.idCob;
            polCobsDescTemp["codDesc"] = x.descuentos[0].codigoDescuento;
            polCobsDescTemp["pdescuento"] = pdescuento;
            polCobsDescTemp["mdescuento"] = descuento;
            polCobsDescTemp["fechaingreso"] = Date.now;
            polCobsDesc.push(polCobsDescTemp);
        }

        if (x.idCob == coberturaEquipoEspecial) {
            oaTemp = {
                OA_EquipoEspecial: [
                    { Valor: poliza.valorEquipoEspecial, Observaciones: poliza.nombreEquipoEspecial, Tipo: 1 }
                ]
            }
        };
    });

    return {
        ...poliza,
        sa: t.suma,
        plan: poliza.planId,
        beneficiarios: [],
        respuesta: [],
        itipopol: 'I',
        cuotas: poliza.ncuotas,
        frecuencia: getfrecuencia(poliza.ncuotas),
        mInteres: poliza.financiamiento,
        formaPagos: {},
        polCobsDesc: polCobsDesc,
        asegurado: {
            tipoId: (poliza?.asegurado?.tipoId) ?? 3,
            numId: isNullOrEmpty(poliza?.asegurado?.numId) ? '000-010100-0000J' : poliza?.asegurado.numId,
            nombre: isNullOrEmpty(poliza?.asegurado?.nombre) ? 'prueba' : poliza?.asegurado.nombre,
            apellido: isNullOrEmpty(poliza?.asegurado?.apellido) ? 'prueba' : poliza?.asegurado.apellido,
            estadoCivil: 0,
            fechaNacimiento: '2021-12-27',
            profesion: 0,
            ocupacion: 0,
            sexo: 'M',
            actividad: 0,
            origenFondos: 0,
            OrigenFondosDetalle: '',
            Direccion: '',
            Departamento: 0,
            Municipio: 0,
            TelefonoCasa: '',
            TelefonoCelular: poliza?.asegurado?.TelefonoCelular,
            Email: poliza?.asegurado?.email,
            CasaPropia: null,
            TieneHijos: null,
            VehiculoPropio: null,
            NombreEmp: '',
            TelefonoEmp: '',
            ...poliza.asegurado
        },
        au: {
            tipo: 'AU',
            ramo: 1,
            sa: t.suma,
            auMarca: getCatalogText(catalogos, 'marcas', t.marc),
            auModelo: getCatalogText(catalogos, 'modelos', t.mode),
            auAnio: t.anio,
            auTipo: t.auTipo,
            auCategoria: t.auCategoria,
            auValorNuevo: t.valn,
            auNumPasajeros: t.auNumPasajeros,
            auUso: t.usoo,
            cia: 3,
            codigoMarca: t.marc,
            codigoModelo: t.mode,
            auGPS: t.GPS,
            auNuevo: t.auNuevo,
            ideducible: t.dedu,
            irastreoSatelital: t.rsat,
            auColor: poliza.color,
            auMotor: poliza.motor,
            auChasis: poliza.chasis,
            auPlaca: poliza.placa,
            auNoPuertas: poliza.npuertas,
            auCombustible: poliza.combustible,
            auCilindros: poliza.ncilindros,
            auTipoTransmision: poliza.transmision,
            auClaseveh: poliza.clasevh
        },
        Oa: oaTemp.OA_EquipoEspecial ? { OA_EquipoEspecial: oaTemp.OA_EquipoEspecial } : {}
    };
}

const getCatalogText = (catalogs, name, value) => {
    if (catalogs[name] != null) {
        let c = catalogs[name].find(x => x.value == value);
        if (c != null)
            return c.text;
    }
    return '';
}

export const coverageDefault = {
    cobId: 0,
    name: '',
    sa: '',
    prima: '',
    sumInsureds: [],
    checked: false,
    selectedSA: null
}

export const isOldVh = (anio) => {
    const d = new Date();
    let year = d.getFullYear();

    return anio != null && (year - Number.parseInt(anio)) >= 15
}

export const existeCoberturaEquipoEspecial = (t) => {
    let cob = t[`Cob${coberturaEquipoEspecial}`]
    if (cob === undefined || cob === null)
        return false;
    return (cob === 1);
}

const getDataEnte = (data) => {

    let sexVal = '';
    let statusCivilVal = '';
    let sexDetail = sexo.find(x => x.value === data.sexo)
    if (sexDetail !== undefined)
        sexVal = sexDetail.text2;
    let statusCivilDetail = estadoCivil.find(x => x.value === data.estadoCivil)
    if (statusCivilDetail !== undefined)
        statusCivilVal = statusCivilDetail.text2;

    let ente = {
        "Nombre": data.asegurado.nombre,
        "Apellido": data.asegurado.apellido,
        "TelefonoCelular": data.asegurado.celular,
        "Email": data.asegurado.email,
        "TipoId": data.asegurado.tipoId,       
        "Nacionalidad": formatNumber(data.nacionalidad),
        "Sexo": sexVal,
        "FechaNacimiento": data.fechaNacimiento,
        "Profesion": data.profesion,
        "Direccion": data.direccion,
        "EstadoCivil": statusCivilVal,
        "Departamento": data.departamento,
        "Municipio": data.ciudad,
        "Distrito": data.municipio,
        "CasaPropia": data.hasHouse,
        "TieneHijos": data.hasChildren,
        "TelefonoCasa": data.telefonoCasa,
        "Actividad": data.actividad,
        "Ocupacion": data.ocupacion,
        "OrigenFondos": data.origenFondo,
        "EmpreLab": data.empresaTrabaja,
        "IngresoMensual": +data.ingresoMensual,
        "TelefonoEmp": data.telefono,
        "CMonedaIngresos": "U$",
        //"": data.ingresoMoneda
        "NombreConyuge": `${ValidString(data.nombreConyuge)} ${ValidString(data.apellidoConyuge)}`, // ambos nombres
        'NumId': data.asegurado.identificacion
    }
    return ente;
}



const getDataEnte2 = (data) => {
     console.log(data);

    let sexVal = '';
    let statusCivilVal = '';
    let sexDetail = sexo.find(x => x.value === data.sexo)
    if (sexDetail !== undefined)
        sexVal = sexDetail.text2;
    let statusCivilDetail = estadoCivil.find(x => x.value === data.estadoCivil)
    if (statusCivilDetail !== undefined)
        statusCivilVal = statusCivilDetail.text2;

    let ente = {
        Nombre: data.asegurado.nombre,
        Apellido: data.asegurado.apellido,
        TelefonoCelular: data.asegurado.celular,
        Email: data.asegurado.email,
        TipoId: data.asegurado.tipoId,       
        Nacionalidad: formatNumber(data.nacionalidad),
        Sexo: sexVal,
        FechaNacimiento: data.fechaNacimiento,
        Profesion: data.profesion,
        Direccion: data.direccion,
        EstadoCivil: statusCivilVal,
        Departamento: data.departamento,
        Municipio: data.ciudad,
        Distrito: data.municipio,
        CasaPropia: data.hasHouse,
        TieneHijos: data.hasChildren,
        TelefonoCasa: data.telefonoCasa,
        Actividad: formatNumber(data.actividad),//
        Ocupacion: formatNumber(data.ocupacion),//
        OrigenFondos: formatNumber(data.origenFondo),//
        EmpreLab: ValidString(data.empresaTrabaja),//
        IngresoMensual: formatNumber(data.ingresoMensual),//
        TelefonoEmp: ValidString(data.telefono),//
        CMonedaIngresos: "U$",        
        NombreConyuge: `${ValidString(data.nombreConyuge)} ${ValidString(data.apellidoConyuge)}`, // ambos nombres
        NumId: data.asegurado.numId
    }
    return ente;
}

const ValidString = (val) => (val === undefined || val === null) ? '' : val;

export { initPage, setData, getDataEnte2 };